
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartShallowPatternIec as ObiChartShallowPatternIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-shallow-pattern-iec.js';
 
 
 

 
 export const ObiChartShallowPatternIec = createComponent({
   react: React,
   tagName: 'obi-chart-shallow-pattern-iec',
   elementClass: ObiChartShallowPatternIecElement,
   events: {
     
   }
  });
 
 